import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IconComponent } from './icon/icon.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { ModalComponent } from './modal/modal.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ToastNotificationsComponent } from './toast-notifications/toast-notifications.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { CircularProgressComponent } from './circular-progress/circular-progress.component';
import { LoadComponentDirective } from './load-component/load-component.directive';
import { TranslateModule } from '@ngx-translate/core';
import { AfterDateValidatorDirective } from './after-date-validator.directive';
import { DateTranslationPipe } from './date-translation.pipe';
import {CourseFilterComponent} from "./course-filter/course-filter.component";
import {ActivateCourseModalComponent} from "./activate-course-modal/activate-course-modal.component";
import { TopBarUserMenuComponent } from './top-bar-user-menu/top-bar-user-menu.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import {ContactUsModalComponent} from "./contact-us-modal/contact-us-modal.component";
import {FormsModule} from "@angular/forms";
import { BootstrapTooltipDirective } from './bootstrap-tooltip.directive';

@NgModule({
  declarations: [
    IconComponent,
    TopBarComponent,
    ModalComponent,
    ConfirmDialogComponent,
    ToastNotificationsComponent,
    PaginatorComponent,
    SpinnerComponent,
    CircularProgressComponent,
    LoadComponentDirective,
    AfterDateValidatorDirective,
    DateTranslationPipe,
    CourseFilterComponent,
    ActivateCourseModalComponent,
    TopBarUserMenuComponent,
    ErrorModalComponent,
    ContactUsModalComponent,
    BootstrapTooltipDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule
  ],
  exports: [
    IconComponent,
    TopBarComponent,
    ModalComponent,
    ConfirmDialogComponent,
    ToastNotificationsComponent,
    PaginatorComponent,
    SpinnerComponent,
    CircularProgressComponent,
    LoadComponentDirective,
    TranslateModule,
    AfterDateValidatorDirective,
    DateTranslationPipe,
    CourseFilterComponent,
    ActivateCourseModalComponent,
    TopBarUserMenuComponent,
    ErrorModalComponent,
    ContactUsModalComponent,
    BootstrapTooltipDirective
  ]
})
export class UtilsModule { }
